<template>
    <v-dialog v-model="mostrar" persistent max-width="500px">
        <v-card :loading="loading">
            <v-card-title>
            <span class="headline">Nuevo usuario</span>
            </v-card-title>

            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12" sm="3" md="3">
                            <v-text-field 
                                v-model="codigo" 
                                name="SG-NU-codigo" 
                                label="Código:"
                                :error-messages="errors.codigo"
                                @input="validarCodigo()"
                                @blur="validarCodigo()"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                            <v-select
                            :items="titulos"
                            v-model="titulo"
                            label="Título:"
                            ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <v-text-field 
                                v-model="nombre" 
                                name="SG-NU-nombre" 
                                label="Nombre(s):"
                                :error-messages="errors.nombre"
                                @input="validarNombre()"
                                @blur="validarNombre()"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <v-text-field 
                                v-model="paterno" 
                                name="SG-NU-paterno" 
                                label="Paterno:"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <v-text-field 
                                v-model="materno" 
                                name="SG-NU-materno" 
                                label="Materno:">
                            </v-text-field>
                        </v-col>

                        <!-- <v-col class="d-flex" cols="12" sm="6">
                            <v-select
                            :items="sexos"
                            v-model="sexoSel"
                            label="Sexo:"
                            ></v-select>
                        </v-col> -->
                        <v-col class="d-flex" cols="12" sm="6">
                            <v-select
                            :items="statusList"
                            v-model="status"
                            label="Status:"
                            ></v-select>
                        </v-col>
                        <v-col class="d-flex" cols="12" sm="6">
                            <v-select
                            :items="roles"
                            v-model="roleSel"
                            label="Rol:"
                            ></v-select>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                            <v-text-field 
                                v-model="correo" 
                                name="SG-NU-Correo" 
                                label="Correo:"
                                :error-messages="errors.correo"
                                @input="validarCorreo()"
                                @blur="validarCorreo()"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                            <v-text-field 
                                v-model="puesto" 
                                name="SG-NU-puesto" 
                                label="Puesto:"
                                :error-messages="errors.puesto"
                                @input="validarPuesto()"
                                @blur="validarPuesto()"
                                >
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="blue-grey darken-1" outlined text @click="$emit('cancelar')">Cancelar</v-btn>
            <v-btn color="blue-grey darken-1" dark @click="guardarUsuario()">Guardar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
       
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, minLength, email } from 'vuelidate/lib/validators'
import axios from 'axios'
import { mapGetters} from 'vuex'

export default {
    props:['mostrar','id'],
    mixins: [validationMixin],
    data: () => ({
        loading: false,
        codigo: null,
        nombre: null,
        paterno: null,
        materno: null,
        correo: null,
        puesto: null,
        titulo: 'C.',
        status: null,
        sexoSel: 'Masculino',
        sexos: ['Masculino', 'Femenino'],
        roleSel: 'user',
        roles: [
            {value: 'user', text: 'Usuario'},
            {value: 'admin', text: 'Administrador'},
            {value: 'super-admin', text: 'Súper Administrador'}
        ],
        titulos:['C.', 'Lic.', 'Mtro.', 'Mtra.', 'Dr.', 'Dra.'],
        statusList: ['Activo', 'Inactivo'],
        errors:{
            codigo: [],
            nombre: [],
            correo: [],
        },
    }),
    validations: {
        codigo: { required, minLength: minLength(5) },
        nombre: { required, minLength: minLength(1) },
        correo: { required, email },
        puesto: { required, minLength: minLength(5) },
    },
    computed: {
        ...mapGetters([
            "httpURL",
            "sessionToken"
        ])
    },
    created(){
        this.loading = true;
        axios.get(this.httpURL+'/usuario/'+this.id,{headers:{token:this.sessionToken}})
        .then(res => {
            // console.log(res.data);
            if( res.data.ok ){
                this.codigo = res.data.usuario.codigo;
                this.titulo = res.data.usuario.titulo;
                this.paterno = res.data.usuario.paterno;
                this.materno = res.data.usuario.materno;
                this.nombre = res.data.usuario.nombre;
                // this.sexoSel = res.data.usuario.sexo;
                this.roleSel = res.data.usuario.role;
                this.correo = res.data.usuario.correo;
                this.puesto = res.data.usuario.puesto;
                this.status = res.data.usuario.status;
                this.loading = false;
            }else{
                this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: res.data.mensaje });
                this.loading = false;
            }
        })
        .catch(error => {
            // console.log('Error: '+error);
            this.loading = false;
            this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: 'Ocurrió un error al hacer la petición' });
        });
    },
    methods: {
        validarCodigo(){
            this.$v.codigo.$touch();
            const errors = []
            if (this.$v.codigo.$dirty){
                !this.$v.codigo.required && errors.push('Campo requerido.')
                !this.$v.codigo.minLength && errors.push('Mínimo 5 caracteres.')
            }
            this.errors.codigo = errors;
        },
        validarNombre(){
            this.$v.nombre.$touch();
            const errors = []
            if (this.$v.nombre.$dirty){
                !this.$v.nombre.required && errors.push('Campo requerido.')
            }
            this.errors.nombre = errors;
        },
        validarCorreo(){
            this.$v.correo.$touch();
            const errors = []
            if (this.$v.correo.$dirty){
                !this.$v.correo.required && errors.push('Campo requerido.');
                !this.$v.correo.email && errors.push('Correo no válido.');
            }
            this.errors.correo = errors;
        },
        validarPuesto(){
            this.$v.puesto.$touch();
            const errors = []
            if (this.$v.puesto.$dirty){
                !this.$v.puesto.required && errors.push('Campo requerido.')
                !this.$v.puesto.minLength && errors.push('Mínimo 5 caracteres.')
            }
            this.errors.puesto = errors;
        },
        guardarUsuario(){
            this.$v.$touch();
            this.validarCodigo();
            this.validarNombre();
            this.validarCorreo();
            this.validarPuesto();
            if (!this.$v.$invalid) {
                this.loading = true;
                axios.put(this.httpURL+'/usuario/'+this.id,
                {
                    codigo: this.codigo,
                    titulo: this.titulo,
                    paterno: this.paterno,
                    materno: this.materno,
                    nombre: this.nombre,
                    sexo: this.sexoSel,
                    role: this.roleSel,
                    correo: this.correo,
                    puesto: this.puesto,
                    status: this.status
                },
                {headers:{token:this.sessionToken}})
                .then(res => {
                    // console.log(res.data);
                    if( res.data.ok ){
                        this.$emit('usuarioModificado',{usuario:res.data.usuario, log:res.data.log});
                        this.loading = false;
                    }else{
                        if( res.data.codigo ) this.errors.codigo = [res.data.mensaje];
                        if( res.data.correo ) this.errors.correo = [res.data.mensaje];
                        if( !res.data.codigo && !res.data.correo )
                            this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: res.data.mensaje });
                        this.loading = false;
                    }
                })
                .catch(error => {
                    // console.log('Error: '+error);
                    this.loading = false;
                    this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: 'Ocurrió un error al hacer la petición' });
                });
            }
        }
    }
}
</script>